<template>
  <SessionComplete :session="session">
    <div v-html="message"></div>
  </SessionComplete>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SessionResult } from '../constants'
import SessionComplete from './SessionComplete'

export default {
  name: 'Logout',
  components: {SessionComplete},
  data: function() {
    return {
      message: null
    }
  },
  computed: {
    ...mapState(['session']),
    ...mapGetters(['isSessionActive'])
  },
  created() {
    this.$store.commit('clear_error')
    this.message = ('msg' in this.$route.query && this.$route.query.msg && this.$route.query.msg.length)
      ? this.$route.query.msg : 'You have been logged out.'

    if (this.isSessionActive) {
      this.$store.commit('busy')
      this.$store.dispatch('update_session', {result: SessionResult.Logout, message: this.message})
        .finally(() => {
          this.$store.commit('logout')
          this.$store.commit('set_cart', [])
          this.$store.commit('ready')
        })
    } else {
      this.$store.commit('logout')
    }
  }
}
</script>

<style scoped>

</style>
